<template>
  <div class="AccordionItem mb-4">
    <div
      :class="{
        'bg-dark-red': isCurrent,
        'text-white': isCurrent,
        'border-dark-red': isCurrent,
      }"
      class="AccordionItem__Title text-left text-xl border-2 border-grey-darker p-3 rounded cursor-pointer flex items-center"
      @click="toggleAccordionItem"
    >
      {{ title }}
      <span class="ml-auto">
        <i
          v-if="isCurrent"
          class="mps mps-triangle-down text-orange text-white"
        />
        <i
          v-else
          class="mps mps-triangle-right text-dark-red"
        />
      </span>
    </div>
    <div
      :class="{ isHidden: !isCurrent}"
      class="AccordionItem__Content py-4 px-3 text-left"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  inject: {
    accordionOptions: {
      default: () => ({ current: null })
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    isCurrent () {
      return this.accordionOptions.current === this._uid
    }
  },
  methods: {
    toggleAccordionItem () {
      if (this.isCurrent) {
        this.accordionOptions.current = null
      } else {
        this.accordionOptions.current = this._uid
      }
    }
  }
}
</script>

<style rel='stylesheet/scss' lang='scss'>
@import '~utils';

.AccordionItem__Content {
  max-height: 500px;
  transition: .3s linear;
  overflow: hidden;

  &.isHidden {
    max-height: 0;
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
